import type {
  AuthoredEntityOrSingleSchema,
  LoadedAuthoredGeneratedSchema
} from '@cli-types/core-engine/add-field.js'
import type { FormSchema } from '@cli-types/core-engine/schema.js'
import { collectFormPersistedNames } from './collect-form-persisted-names.js'
import { collectSchemaPersistedNames } from './collect-schema-persisted-names.js'
import { getAuthoredSchemaRootFields } from './get-authored-schema-root-fields.js'

export function collectFieldNameValidationErrors(loaded: LoadedAuthoredGeneratedSchema): string[] {
  const errors: string[] = []
  const occurrences = new Map<string, string[]>()

  if (loaded.kind === 'form') {
    const schema = loaded.schema as FormSchema
    const rootFields = schema.steps
      ? schema.steps.flatMap((step) => step.fields)
      : (schema.fields ?? [])
    collectFormPersistedNames(rootFields, 'fields', occurrences, errors)
  } else {
    const schema = loaded.schema as AuthoredEntityOrSingleSchema
    collectSchemaPersistedNames(getAuthoredSchemaRootFields(schema), 'fields', occurrences, errors)
  }

  for (const [name, paths] of occurrences) {
    if (paths.length > 1) {
      errors.push(`Duplicate persisted field name "${name}" found at ${paths.join(', ')}.`)
    }
  }

  return errors
}
